import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subscription} from 'rxjs';
import {StoreService} from '../../../../../services/store.service';
import {AuthService} from '../../../../../services/auth.service';
import {NotificationService} from '../../../../../services/notification.service';
import {ActivatedRoute} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {AppSettings} from '../../../../../config/AppSettings';
import {IfaMember} from '../../../../../forms/ifa-member';
import {FbFormObject} from '../../../../../class/fb_form_object';

@Component({
  selector: 'app-edit-ifa-member',
  templateUrl: './edit-ifa-member.component.html',
  styleUrls: ['./edit-ifa-member.component.css']
})
export class EditIfaMemberComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('select_caption_tpl', {static: true}) set select_caption_tpl(value: ElementRef) {
    this._select_caption_tpl = value;
    this.cdr.markForCheck();
  }

  public loading_text = '';
  public is_loading = true;
  public fields: any[];
  public mode = 'edit';
  public edit = false;
  public rows = [];
  public count = 0;

  private subs: Array<Subscription> = [];
  private record: any;
  private id: string|number = '';
  private storeObj: FbFormObject;

  private _select_caption_tpl: ElementRef;

  constructor(private storeService: StoreService,
              private authService: AuthService,
              private notificationService: NotificationService,
              private route: ActivatedRoute,
              private cdr: ChangeDetectorRef,
              public dialog: MatDialog) {
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    this.subs.push(this.route.params.subscribe((params: any) => {
      this.edit = this.authService.isAdmin() || this.authService.hasRole(AppSettings.ifa_guild_id, AppSettings.group_page_admin);

      if (params.id && params.id !== 'add') {
        this.mode = 'edit';
        this.id = params.id;
      } else {
        this.mode = 'add';
        // this.edit = true;
      }

      const filter = [];
      filter.push('filter[user_id][0][mode]=equals');
      filter.push('filter[user_id][0][operator]=and');
      filter.push('filter[user_id][0][value]=' + this.id);
      filter.push('first=0');
      filter.push('rows=1');

      this.storeObj = new IfaMember(this.storeService, this.authService, this.mode);
      this.storeObj.init({select_caption_tpl: this._select_caption_tpl}, {},
          '?' + filter.join('&')).then((success) => {
        this.fields = this.storeObj.getEditFields();
        if (this.id && this.id !== '' && this.mode === 'edit') {
          const rec = this.storeObj.getStore().getRecordById(this.id);
          if (rec) {
            this.record = rec;
          }
        } else {
          this.resetModel();
        }
        this.rebuildForm();
        this.is_loading = false;
      });

    }));
  }

  public rebuildForm() {
    this.fields = [];
    this.cdr.detectChanges();
    this.fields = this.storeObj.getForm(this.record.data);
    this.cdr.detectChanges();
  }

  private resetModel() {
    this.record = this.storeObj.getDefaultModel();
  }

  public saveStore(event: any) {
    if (this.mode === 'edit') {
      this.storeObj.getStore().addRecord(this.record.data, '').then((res) => {
        if (res && res.success) {
          this.notificationService.success('Data',
              'Speichern erfolgreich.', {timeOut: 5000});
          this.resetModel();
          this.rebuildForm();
        } else {
          this.notificationService.error('Data',
              'Speichern fehlgeschlagen.', {timeOut: 5000});
        }
      });
    }
  }


  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
    if (this.mode === 'edit') {
      this.storeObj.getStore().revertRecord(this.record);
    }
  }
}
